import styled from 'styled-components';
import { Typography, Modal } from 'antd';

import colors from '../../../styles/colors';

const { Text } = Typography;

export const ModalContainer = styled(Modal)`
  .ant-modal-content {
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.16);
    border-radius: 8px;
    padding: 32px 8px 36px 0;
    background: #f1f4f5;
    .ant-modal-header {
      background: #f1f4f5;
      padding: 0px 24px;
      border: none;
    }

    .ant-modal-body {
      overflow-x: auto;
      height: 80vh;

      ::-webkit-scrollbar {
        width: 6px;
        border-radius: 8px;
        border: none;
      }

      ::-webkit-scrollbar-track {
        background: #e0e0e0;
        border-radius: 8px;
      }
      ::-webkit-scrollbar-thumb {
        background-color: #bdbdbd;
        border-radius: 8px;
      }
    }
  }
`;

export const ModalTitlesolicitacao = styled(Typography.Text)`
  font-weight: ${props => props.weight || '600'};
  font-size: ${props => props.size || '16px'};
  line-height: 20px;
  color: ${props => props.color || colors.primary};
  .ant-badge-status-dot {
    width: 12px;
    height: 12px;
  }
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ModalText = styled(Text)`
  font-size: 12px;
  line-height: 20px;
  font-weight: ${props => (props.value ? 400 : 500)};
  color: ${props => (props.value ? '#0D3549' : '#2D3A40')};
  margin-left: ${props => (props.value ? '30px' : '2px')};
  > pre {
    font-size: 12px;
    background: transparent;
    border: none;
    font-family: Roboto;
    padding: 0;
    margin: 0;
  }
`;

export const BadgeStatus = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: ${props => props.color || colors.primary};

`;

export const StatusIcon = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  margin: 0 8px 0 8px;
  background: ${props => props.color || colors.primary};
`;
